<template>
  <q-chip
    class="q-pl-none shadow-2"
    :dense="dense"
    :class="{['bg-' + color + '-' + colorOffset]: true, 'q-pr-md': removable && !dense, 'q-pr-sm': removable && dense, 'q-pr-none': !removable}"
    :removable="removable"
    :ripple="false"
    @remove="$emit('remove')"
  >
    <div class="flex align-center overflow-hidden">
      <q-chip
        class="q-ma-none"
        :dense="dense"
        :class="{['bg-' + color + '-' + (colorOffset - 1)]: true, ['text-' + textColor]: true, 'text-caption': small}"
        :clickable="clickable"
        :title="invoice.invoice_number"
        @click="$emit('click')"
      >
        <div>
          {{ truncateString(invoice.invoice_number) }}
          <slot name="caption" />
        </div>
      </q-chip>
    </div>
  </q-chip>
</template>

<script>

export default {
  props: {
    invoice: {
      type: Object,
      required: true
    },
    clickable: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'grey'
    },
    textColor: {
      type: String,
      default: 'black'
    },
    btnColor: {
      type: String,
      default: 'blue-grey'
    },
    colorOffset: {
      type: Number,
      default: 2
    },
    dense: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    withoutBtns: {
      type: [Boolean, Object],
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click', 'remove']
}
</script>
